




















import thai from '@/assets/images/thailand.png';
import usa from '@/assets/images/usa.png';
import ar from '@/assets/images/ar.png';
import cn from '@/assets/images/cn.png';
import de from '@/assets/images/de.png';
import es from '@/assets/images/es.png';
import hi from '@/assets/images/hi.png';
import id from '@/assets/images/id.png';
import jp from '@/assets/images/jp.png';
import ko from '@/assets/images/ko.png';
import my from '@/assets/images/my.png';
import ph from '@/assets/images/ph.png';
import pt from '@/assets/images/pt.png';
import rs from '@/assets/images/rs.png';
import vn from '@/assets/images/vn.png';
import zh from '@/assets/images/zh.png';

import { Vue, Component } from 'vue-property-decorator';

@Component
export default class LanguageButton extends Vue {
  localeList = [
    {
      name: 'ไทย',
      value: 'th',
      pic: thai,
    },
    {
      name: 'English',
      value: 'en',
      pic: usa,
    },
    {
      name: '中文',
      value: 'zh',
      pic: zh,
    },
    {
      name: 'Tiếng Việt',
      value: 'vn',
      pic: vn,
    },
    {
      name: 'Русский',
      value: 'rs',
      pic: rs,
    },
    {
      name: 'Português',
      value: 'pt',
      pic: pt,
    },
    {
      name: 'Filipino',
      value: 'ph',
      pic: ph,
    },
    {
      name: 'Arabic',
      value: 'ar',
      pic: ar,
    },
    {
      name: '中文',
      value: 'cn',
      pic: cn,
    },
    {
      name: 'Deutsch',
      value: 'de',
      pic: de,
    },
    {
      name: 'Español',
      value: 'es',
      pic: es,
    },
    {
      name: 'हिन्दी',
      value: 'hi',
      pic: hi,
    },
    {
      name: 'Bahasa Indonesia',
      value: 'id',
      pic: id,
    },
    {
      name: '日本語',
      value: 'jp',
      pic: jp,
    },
    {
      name: '한국어',
      value: 'ko',
      pic: ko,
    },
    {
      name: 'မြန်မာ',
      value: 'my',
      pic: my,
    },
  ];

  currentLocale: any = {};

  created() {
    const language = JSON.parse(localStorage.getItem('language') || '{}');
    this.currentLocale = language && language.value ? language : this.localeList[1];
    this.$i18n.locale = language.value;
  }

  handleLocale(value) {
    this.$i18n.locale = value;
    this.setCurrentLocale();
  }

  setCurrentLocale() {
    this.currentLocale = this.localeList.find((item) => item.value === this.$i18n.locale);
    localStorage.setItem('language', JSON.stringify(this.currentLocale));
  }

  colorflagName() {
    if (window.location.pathname === '/login') {
      return 'flag-name-login';
    } else {
      return 'flag-name';
    }
  }
}
